import { Outlet } from "react-router-dom";
import TopNav from './Top/Top';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function MainLayout() {
  return (
    <>
      <header>
        <Container fluid style={{ backgroundColor: 'black' }}>
          {/* <h1 style={{margin: '0px', color:'white'}}>PavlovLab</h1> */}
        </Container>
      </header>
      <main>
        <Container fluid style={{ backgroundColor: 'blue' }}>
          <Row style={{backgroundColor: 'green'}}>
              <TopNav/>
          </Row>
          <Row>
            <Outlet></Outlet>
          </Row>
        </Container>
      </main>
      <footer>
        <Container fluid style={{ backgroundColor: 'black'}} className="text-start">
            <h5 style={{margin: '0px', color:'white'}}>@copyright</h5>
        </Container>
      </footer>        
    </>
  )
}

export default MainLayout
